
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/eTail-data-lake",
      function () {
        return require("private-next-pages/eTail-data-lake.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/eTail-data-lake"])
      });
    }
  